import { compose, withHandlers } from 'recompose';
import FileEntry from "./FileEntry";
var enhancer = compose(withHandlers({
  onRemove: function onRemove(_ref) {
    var idx = _ref.idx,
      removeFile = _ref.removeFile;
    return function (event) {
      if (event) event.stopPropagation();
      return removeFile(idx);
    };
  }
}));
export default enhancer(FileEntry);